/**
 * Product Form Components
 *
 */
var varMetafielsJson = [];
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');
    this.productTitle = this.dataset.productTitle || '';
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

    if(this.form.querySelector("[data-variantMetafieldJSON]")){
      varMetafielsJson =  JSON.parse(this.form.querySelector("[data-variantMetafieldJSON]").innerHTML);
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();

    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');

    if (window.globalVariables.template == 'product') {
      if(submitButton.getAttribute('data-open-notify')){
        const checkForKlaviyoLink = setInterval(function() {
          const klaviyoLink = document.querySelector('#product-form-installment .klaviyo-bis-trigger');
          if (klaviyoLink) {
            clearInterval(checkForKlaviyoLink);
            klaviyoLink.click();
          }
        }, 500);
        return false;
      }

      if (document.querySelectorAll("[data-variant-picker-wrap]").length > 0 ) {
        let flag = false;
        let optName = 'Please select the Variant.';
        let count = 0;
       
        document.querySelectorAll("[data-variant-picker-wrap]").forEach(ele=>{            
           if (ele.querySelector('li.selected input').value == 'null' || ele.querySelector('li.selected input').value == null) {
             flag = true;
             count = count + 1;
             optName = `Please select the ${ele.getAttribute('data-name')}.`;
           }    
        });
        if(flag == true){
          document.querySelector("[is-variant-selected]").textContent = count == document.querySelectorAll("[data-variant-picker-wrap]").length ? 'Please select the Variant.' : optName;
          document.querySelector("[is-variant-selected]").classList.remove("d-none");
          return true;
        }
      }
    }   

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(serializeForm(this.form)))
    if(pdpContainer){
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
        if(!addOn.disabled){
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }

    const body = JSON.stringify({
      items: addItems
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((data) => {
        if(data.errors || data.status == '422'){
          // console.log(window.globalVariables.product.currentVariant); 
         let variantQtyLimit =  document.querySelector('[data-not-enough-qty-available]');
         if(variantQtyLimit){ variantQtyLimit.innerHTML = `You can only add ${window.globalVariables.product.currentVariant.inventory_quantity} ${window.globalVariables.product.currentVariant.name} to the cart.`};
         variantQtyLimit.classList.remove('d-none');
          return;
        }
        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        this.cartElement.getCartData('open_drawer');
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.log('cart-error'); 
        console.error(e);
      })
      .finally(() => {
        console.log('finally');
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if(action == 'decrease' && currentQty <= 1){
        return false;
    }else if(action == 'decrease'){
        finalQty = currentQty - 1;
    }else{
        finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
    if ($qtyInput.value == 1 ) {
      if (document.querySelectorAll("[data-decrease-btn]").length > 0) {
        document.querySelector("[data-decrease-btn]").classList.add("disabled");
      }
    }else{
      if (document.querySelectorAll("[data-decrease-btn]").length > 0) {
        document.querySelector("[data-decrease-btn]").classList.remove("disabled");
      }
    }
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.form =  this.closest('[pdp-form]') || this.closest('form');
    this.formType = this.form.dataset.format;
   
    if (window.globalVariables.template == 'product') {
      this.formType = 'product-page';
    }
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');

    this.variantPicker = this.dataset.type;

    if(this.formType == 'product-page'){
      // if(this.getAttribute('data-optsize') == 1){
        this.onVariantChange('load');
      // }
    }
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.addEventListener('click', ()=>{
      if (document.querySelectorAll("[data-notify-meg]").length > 0) {
        document.querySelectorAll("[data-notify-meg]").forEach(ele=>{   
            ele.classList.remove("d-none");
        });
      }
    });
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {

  if(_event != 'load' && _event.target.closest('[data-optionindex="1"]') != null && this.form.querySelector('[data-optionindex="2"]') != null){
    this.form.querySelector('[data-optionindex="2"] .option_txt').textContent = this.form.querySelector('[data-optionindex="2"] ul li label').textContent;
    this.form.querySelector('[data-optionindex="2"] ul li').classList.add('selected');
    this.form.querySelector('[data-optionindex="2"] ul li input').checked = true;
  }

  let hasOOS = window.globalVariables.product.variants.find((x)=> x.available == false);

    if (document.querySelectorAll("[data-notify-meg]").length > 0 && _event != 'load' && (hasOOS != undefined || hasOOS != null)) {      
      document.querySelectorAll("[data-notify-meg]").forEach(ele=>{   
          ele.classList.remove("d-none");
      });
    }

    this.setCurrentVariant();
    
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
   
    if (this.currentVariant.available == false) {
      this.form.querySelector("[data-qty-container]").classList.add("disabled");
    }else{
      this.form.querySelector("[data-qty-container]").classList.remove("disabled");
    }
    if (!this.currentVariant) {
      this.toggleAddButton('disable',this.currentVariant);
      
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let labelID = 'option'+option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const label = option.querySelector('.selected-option');
        if(!label || !labelID || !selectedValue) return;
        label.innerHTML = selectedValue.value;
      });
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      if (this.currentVariant.available == true) {
        this.toggleAddButton('enable',this.currentVariant);
      }else{
        this.toggleAddButton('disable',this.currentVariant);
      }
      
    }

    if (window.globalVariables.template == 'product') {
      document.querySelector("[is-variant-selected]").classList.add("d-none");
      document.querySelector('[data-not-enough-qty-available]')?.classList.add("d-none");
      if (document.querySelectorAll("[data-variant-picker-wrap]").length > 0 ) {
        let flag = false;

        document.querySelectorAll("[data-variant-picker-wrap]").forEach(ele=>{
          ele.querySelectorAll('li.selected').forEach(eleN=>{
           if (eleN.querySelector('input').value == 'null' || eleN.querySelector('input').value == null) {
             flag = true;
           }
          });       
        });
        
        if(flag == true){
          document.querySelector("[data-pdp-atc]").value="Add to cart";
          document.querySelector("[data-pdp-atc]").closest('.button-submit').setAttribute("disabled", "false")
        }
      }
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

/**
   * Fetch selected options from dropdown
   */
 _getOptionsFromSelectN() {
  let options = [];
  this.querySelectorAll('.custom--select').forEach((selector)=>{
    options.push(selector.querySelector('li.selected input').value);
  });
  return options;
}

  /**
   * Fetch selected options from dropdown
   */
  
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('custom-select').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    // let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelectN() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();

    if(options.length > 1) {

      if(options[0] != 'null' && options[1] == 'null') {
        let avilVar = [];
        variantsArray.forEach((x) =>{
          if(x.option1 === options[0])
            avilVar.push(x);
        });
        
        this.form.querySelectorAll('[data-optionindex="2"] ul li').forEach((selector)=>{
          selector.classList.remove('disabledOption');
          avilVar.forEach((x) => { 
            if(x.option2 == selector.querySelector('input').value){
              if(x.available == false){
                selector.classList.add('disabledOption');
                selector.querySelector('label').textContent = `${x.option2} (Out Of Stock)`;
              } else {
                selector.querySelector('label').textContent = `${x.option2}`;
              }
            }
          });
        });
      }
    }
    
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/false,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('[main-product-form-id]');
    input.value = currentVariant.id;

    //Pass additional variant id for new california store redirection
    if (varMetafielsJson.length > 0) {
      let ref_variant = varMetafielsJson.find(x=> x.variant_id == currentVariant.id);
      document.querySelector("[data-new-store-id]").value = ref_variant.ref_variant_id;
    }
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    //let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    // let comparePriceElement = container.querySelector('[data-comparePrice]');
    /** Merchants wanted to show Sale price if compare price is added, irrespective of its value */
    //console.log(currentVariant.compare_at_price);
    if(currentVariant.compare_at_price != null && currentVariant.compare_at_price > 0){ priceElement.innerHTML =`<b>Sale Price: ${price}</b>`;}else{priceElement.innerHTML =`<b>Our Price: ${price}</b>`; }
    // if(comparePriceElement) {
      // comparePriceElement.innerHTML = `List Price: ${compare_price}` ;
      // if(currentVariant.compare_at_price <= 0){
      //   comparePriceElement.style.display = 'none';
      // }else{
      //   comparePriceElement.style.display = 'block';
      // }
    // }
   
    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.innerHTML = currentVariant[labelID];
    });
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  
  toggleAddButton(status,variant) {
    if (!this.addBtn) return;
    if (document.querySelectorAll("[data-notify-meg]").length > 0 && variant != false) {
      document.querySelectorAll("[data-notify-meg]").forEach(ele=>{        
        if (variant.available == true) {
          ele.classList.remove("active");
        }
          // ele.classList.add("d-none");
        else {
          ele.classList.add("active");
        }
          // ele.classList.remove("d-none");
      });
    }

    if (status == 'disable') {
      // this.addBtn.setAttribute('disabled', true);
      if (variant)
        this.addBtn.querySelector('[data-pdp-atc]').setAttribute('data-open-notify',true);      
      this.addBtn.querySelector('[data-pdp-atc]').value = window.variantStrings.unavailable;        
      if(this.notify_me){
        this.addBtn.classList.remove('d-none');
        this.notify_me.classList.add('d-none');        
      }
    } else if(this.currentVariant && !this.currentVariant.available) {
      // this.addBtn.setAttribute('disabled', true);
      if (variant)
        this.addBtn.querySelector('[data-pdp-atc]').setAttribute('data-open-notify',true);
      this.addBtn.querySelector('[data-pdp-atc]').value = window.variantStrings.soldOut;
        
      if(this.notify_me){
        this.addBtn.classList.add('d-none');
        this.notify_me.classList.remove('d-none');
      }
    } else {
      this.addBtn.querySelector('[data-pdp-atc]').removeAttribute('data-open-notify');
      // this.addBtn.removeAttribute('disabled');
      this.addBtn.querySelector('[data-pdp-atc]').value = window.variantStrings.addToCart;
     
      if(this.notify_me){
        this.addBtn.classList.remove('d-none');
        this.notify_me.classList.add('d-none');
      }
    };
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
  
customElements.define('variant-selects', VariantSelects);
